// eslint-disable-next-line no-unused-vars

export var WaitMixin = {
  name:"WaitMixin",
  data() {
    return {
      wait: false
    }
  },

  watch:{
    wait(value){
      if(value)
        document.querySelector('body').style.cursor = 'progress'
      else
        document.querySelector('body').style.cursor = 'default'
    }
  },

  methods: {
    waitOn(){
      this.wait = true;
    },

    waitOff(){
      this.wait = false;
    }
  },
  
  destroyed() { this.wait = false },
};
